import { GridColDef } from '@mui/x-data-grid';
import React from 'react';

import DataGrid from '#app/Component/DataGrid';
import IconAction from '#app/Component/IconAction';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { transformObjectToDataGridRowsArray } from '#app/Util/DataGridDataTransformer';
import useClientList from '#app/View/Shop/Sale/SelectClient/hooks/useClientList';
import { ClientList } from '#app/typings/client';

type Props = Omit<ReturnType<typeof useClientList>, 'setFilters'>;

const List: React.FC<Props> = ({ clients, loading }) => {
  const columns: GridColDef[] = [
    {
      field: 'number',
      headerName: 'Référence',
      minWidth: 150,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 2,
    },
    {
      field: 'firstname',
      headerName: 'Prénom',
      flex: 1,
    },
    {
      field: 'lastname',
      headerName: 'Nom',
      flex: 1,
    },
    {
      field: 'zipCode',
      headerName: 'Code postal',
      flex: 1,
    },
    {
      field: 'phone',
      headerName: 'Téléphone',
      flex: 1,
    },
    {
      field: 'action',
      headerName: 'Action',
      type: 'actions',
      getActions: ({ row }) => [
        <IconAction
          title="Visualiser"
          icon="view"
          to={getRoutePathname('shop_sales_client_edit', { uuid: row.uuid })}
        />,
      ],
    },
  ];

  return (
    <DataGrid
      rows={transformObjectToDataGridRowsArray<ClientList>(clients)}
      columns={columns}
      loading={loading}
      hideFooter
    />
  );
};

export default List;
